import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { TemplateStatusChip, Divider, Typography, makeStyles, Grid, Card, CardActions, CardContent } from "../../../..";
import selects from "../../../../assets/selects";
import { Link } from "react-router-dom";
var useStyles = makeStyles(function (theme) {
  return {
    flex: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "15px"
    },
    box: {
      "border-radius": "4px",
      border: "1px solid #7d7d7d",
      height: "300px"
    }
  };
});

var TemplateCard = function TemplateCard(_ref) {
  var type = _ref.type,
      translation = _ref.translation,
      props = _objectWithoutProperties(_ref, ["type", "translation"]);

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Link, {
    to: "".concat(props.baseUrl).concat(props._id),
    style: {
      textDecoration: "none"
    }
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.box
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, props.name), props.status && /*#__PURE__*/React.createElement(TemplateStatusChip, {
    status: props.status
  }), type && /*#__PURE__*/React.createElement(TemplateStatusChip, {
    label: translation ? translation.types[type] : selects.bestpractices_types[type]
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, props.description), props.languages && /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: "8px"
    }
  })), props.languages && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, " ", /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Languages")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      display: "flex",
      flexFlow: "row wrap"
    }
  }, props.languages.map(function (language) {
    return /*#__PURE__*/React.createElement(TemplateStatusChip, {
      status: language.status,
      label: language.language,
      style: {
        margin: "4px"
      }
    });
  }))))));
};

export { TemplateCard };